import { get, post, patch } from '../../../api';

export async function loadBillings() {
    const { data } = await get('/api/partner/billings');
    return data;
}
export async function loadBillingsChart() {
    const { data } = await get('/api/partner/billings', { chart: true });
    return data;
}

export async function getPaymentMethod() {
    const { data } = await get('/api/partner/payment_method');
    return data;
}

export async function postPaymentMethod(recurlyTokenId) {
    const data = await post('/api/partner/payment_method', {
        token: recurlyTokenId,
    });
    return data.data;
}

export async function getPaymentInfo() {
    return await get('/api/partner/payment_information');
}

export async function patchPaymentInfo(paymantInfoData) {
    const { status } = await patch(
        '/api/partner/payment_information',
        paymantInfoData
    );
    return status;
}

export async function getTransactions(params) {
    const { data } = await get('/api/partner/transactions', params);
    return data;
}

export async function getSubscriptionSummary() {
    return await get('/api/partner/subscription_summary');
}
